import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Color, GameTree } from '../../../../chess/types'
import { NotificationDialog } from '../../../../components/overlays/NotificationDialog/NotificationDialog'
import useDescriptionText from '../../hooks/useDescriptionText'

interface IProps {
    description?: string
    myColor: Color
    dialog?: {
        open: boolean
        handleClose: () => void
    }
    puzzleGameTree: GameTree
    isVisible?: boolean
}

export const Description: React.FC<IProps> = ({ myColor, description = '', dialog, puzzleGameTree, isVisible = true }) => {
    const [updatedDescription, setUpdatedDescription] = useState<string>('')

    useEffect(() => {
        const positions = puzzleGameTree.positions.filter((position) => position.position.turn === myColor)

        const result = useDescriptionText(description, {
            opponentColor: myColor === Color.Black ? 'White' : 'Black',
            myColor: myColor === Color.Black ? 'Black' : 'White',
            movesCount: positions.length,
        })
        setUpdatedDescription(result)
    }, [puzzleGameTree, description])

    return dialog ? (
        <NotificationDialog
            handleClose={dialog.handleClose}
            open={dialog.open}
            header="description"
            description={updatedDescription}
        />
    ) : (
        isVisible && (
            <Box
                sx={{
                    borderTop: '1px solid',
                    borderColor: 'divider',
                    m: 2,
                    mt: 0,
                    pt: 1,
                    borderRadius: 0,
                    flexGrow: 1,
                }}
            >
                <Typography textAlign="center" variant="h5" color="secondary.main">
                    Description
                </Typography>
                <Typography variant="body2">{updatedDescription}</Typography>
            </Box>
        )
    )
}
